<section>
  <p-messages [(value)]="error"></p-messages>
</section>
